import axios from "../services/APIUtils";
import { apiConfig } from "./config";
import { parseList } from "./utility";

const GetBiddingProjectByVendorId = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/GetAllBiddingProjectForBidding`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetBiddingHistoryByVendorId = async function (VendorId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetAllBiddingProjectHistoryForVendor/${VendorId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetBiddingProjectAnnouncement = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/GetAllBiddingProjectForAnnouncement`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetProjectBiddingDetail = async function (ProjectId, VendorId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProjectForBiddingById/${ProjectId}/${VendorId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetAttachmentTor = async function (ProjectId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetLastAttachmentTOR/${ProjectId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetAttachmentOther = async function (ProjectId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetAllAttachmentOther/${ProjectId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetBlobFileProject = async function (blobName, fileFullName) {
  try {
    axios({
      url: `${apiConfig}/api/BlobAuth/GetBlobByBiddingProject/${blobName}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", fileFullName);
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetBlobFileVendor = async function (blobName, fileFullName) {
  try {
    axios({
      url: `${apiConfig}/api/Blob/GetBlobByVendorSubmitBiddingProject/${blobName}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute("download", fileFullName);
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetProjectItem = async function (ProjectId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProjectItemTemplate/${ProjectId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetBiddingProjectItem = async function (ProjectId, VendorId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProjectVendorSubmitItem/${ProjectId}/${VendorId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetProjectCriteria = async function (ProjectId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProjectVendorCriteria/${ProjectId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const CheckVendorCriteria = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/VendorJoinBiddingProject`,
      payload
    );
    // let data = parseList(response);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const SubmitBiddingItemProject = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/VendorSubmitItemBiddingProject`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetBiddingDetail = async function (ProjectId, VendorId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProjectSelectedVendor/${ProjectId}/${VendorId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const Notjoinbidding = async function (ProjectId, VendorId) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/Notjoinbidding/${ProjectId}/${VendorId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetPublicBiddingDetail = async function (ProjectId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProjectForAnnouncementById/${ProjectId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const DownloadProposalVendorBidding = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/DownloadProposalBiddingProject`,
      payload
    );
    // let data = parseList(response);
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const SubmitFileVendorBidding = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/SubmitUploadFile`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const SubmitBiddingProject = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/VendorSubmitUpdateStatusBiddingProject`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetVendorBiddingAttachment = async function (ProjectId, VendorId, Round) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetSubmitAttachment/${ProjectId}/${VendorId}/${Round}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetVendorLastBiddingAttachment = async function (ProjectId, VendorId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetLastSubmitAttachment/${ProjectId}/${VendorId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetBiddingProjectVendorSubmitItemNegotiate = async function (
  ProjectId,
  VendorId
) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProjectVendorSubmitItem_BiddingNegotiate/${ProjectId}/${VendorId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};
const PostVendorReSubmitItemBiddingProject = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/VendorReSubmitItemBiddingProject`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const SetModelImportPriceVendor = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/SetModelImportPriceVendor`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const SetModelImportPriceVendorNego = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/SetModelImportPriceVendorNego`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetBiddingProjectDocumentByProjectId = async function (ProjectId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProject_Document/${ProjectId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const SubmitUploadFileRow = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/SubmitUploadFileRow`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};
const SubmitUploadFileOtherRow = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/SubmitUploadFileOtherRow`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetLastSubmitAttachmentRow = async function (ProjectId, VendorId) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetLastSubmitAttachmentRow/${ProjectId}/${VendorId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const GetBiddingProjectSelectedVendorSplitPo = async function (
  ProjectId,
  VendorId
) {
  try {
    const response = await axios.get(
      `${apiConfig}/api/BiddingProject/GetBiddingProjectSelectedVendorSplitPo/${ProjectId}/${VendorId}`
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const SubmitUploadFileRowVendorSplitPo = async function (payload) {
  try {
    const response = await axios.post(
      `${apiConfig}/api/BiddingProject/SubmitUploadFileRowVendorSplitPo`,
      payload
    );
    let data = parseList(response);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const _projectservice = {
  GetBiddingProjectByVendorId,
  GetBiddingHistoryByVendorId,
  GetBiddingProjectAnnouncement,
  GetProjectBiddingDetail,
  GetAttachmentTor,
  GetAttachmentOther,
  GetBlobFileProject,
  GetProjectItem,
  GetBiddingProjectItem,
  GetPublicBiddingDetail,
  GetProjectCriteria,
  CheckVendorCriteria,
  SubmitBiddingItemProject,
  GetBiddingDetail,
  DownloadProposalVendorBidding,
  SubmitFileVendorBidding,
  SubmitBiddingProject,
  GetVendorBiddingAttachment,
  GetVendorLastBiddingAttachment,
  GetBlobFileVendor,
  GetBiddingProjectVendorSubmitItemNegotiate,
  PostVendorReSubmitItemBiddingProject,
  SetModelImportPriceVendor,
  SetModelImportPriceVendorNego,
  GetBiddingProjectDocumentByProjectId,
  SubmitUploadFileRow,
  SubmitUploadFileOtherRow,
  GetLastSubmitAttachmentRow,
  GetBiddingProjectSelectedVendorSplitPo,
  SubmitUploadFileRowVendorSplitPo,
  Notjoinbidding,
};
